<script>
  import { fade } from "svelte/transition";
  import Preview from "./Preview.svelte";
  export let obj;

  if (obj.attachments) {
  }
  let time = new Date(parseInt(obj.timestamp)).toISOString().substr(11, 5);
  let photo;
  if (obj?.pic) {
    photo = obj.pic;
  } else {
    photo = "../images/user/user.png";
  }
  let messages = "";
  obj.messages.forEach((a) => {
    if (!a.attachment) {
      messages = messages + a.text;
    }
  });

  let urls = [];
  var pattern =
    /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gm;

  urls = messages.match(pattern);
  let words;
  let tempMessage = messages;
  urls = [...new Set(urls)];

  let message;
  if (urls) {
    urls.forEach((a) => {
      console.log(a);
      console.log("-----------------------------------");
      console.log(tempMessage.indexOf(a));
      console.log("-----------------------------------");
      tempMessage = tempMessage.replaceAll(
        a,
        '<a class="u-link" href="' + a + '" target="_blank">' + a + "</a>"
      );
      console.log(tempMessage);
    });
  }
  message = tempMessage;

  let imagetype = [
    "jpg",
    "JPG",
    "png",
    "PNG",
    "jpeg",
    "JPEG",
    "svg",
    "SVG",
    "gif",
    "GIF",
  ];
  console.log(
    "////////////////////////////////////////////////////////////////"
  );
  console.log(obj.messages);
  console.log(
    "////////////////////////////////////////////////////////////////"
  );
  let preview = "";
  let totalmessage = "";

  obj.messages.forEach((element) => {
    totalmessage = totalmessage + element.text;
  });
</script>

{#if preview}
  <Preview bind:preview />
{/if}
{#if obj}
  <div class="commentContainer" transition:fade={{ duration: 300 }}>
    <div class="leftSide">
      <div class="user-img">
        <img src={photo} alt="temp" />
      </div>
    </div>
    <div class="rightSide">
      <h3>
        <div class="row">
          <div class="username">{obj.username.split(" ")[0]}</div>
          <span>{time}</span>
        </div>
        <div class="paragraphContainer">
          {#if obj.messages}
            <p style="white-space: pre-line;">{@html message}</p>
            {#each obj.messages as message, i}
              {#if message.attachment}
                {#if imagetype.includes(message.attachment?.extension)}
                  <div class="attach">
                    <img
                      on:click={() => {
                        preview = message.attachment.url;
                      }}
                      class="attach-img"
                      src={message.attachment.url}
                      alt=""
                    />
                  </div>
                {:else if message.attachment.extension == "zip"}
                  <div class="attach">
                    <img
                      class="attach-img"
                      src="../images/tasks/zip.svg"
                      alt=""
                    />
                    <div class="attach-name">
                      {message.attachment.title}
                    </div>
                  </div>
                {:else}
                  <div class="attach">
                    <img
                      class="attach-img"
                      src="../images/tasks/file.svg"
                      alt=""
                    />
                    <div class="attach-name">
                      {message.attachment.title}
                    </div>
                  </div>
                {/if}
              {/if}
            {/each}
          {/if}
        </div>
      </h3>
    </div>
  </div>
{/if}

<style>
  * {
    padding: 0;
    margin: 0;
  }

  .commentContainer {
    display: flex;
    flex-direction: row;
    margin-bottom: 1rem;
  }

  .leftSide i {
    font-size: 2em;
  }

  .rightSide {
    padding-left: 1rem;
  }

  .rightSide h3 {
    font-weight: 500;
    font-size: 1em;
    margin-bottom: 0.2rem;
  }

  .rightSide span {
    color: #7d8592;
    font-size: 0.7em;
  }

  .rightSide p {
    font-weight: 400;
    font-size: 0.8em;
    background-color: #3f8cff;
    padding: 0.5rem 1rem;
    border-radius: 12px;
    border-top-left-radius: 0px;
    color: white;
    overflow-wrap: anywhere;
  }

  .rightSide a {
    font-weight: 400;
    font-size: 0.8em;
    background-color: #3f8cff;
    padding: 0.5rem 1rem;
    border-radius: 12px;
    border-top-left-radius: 0px;
    color: #d9d9d9;
    overflow-wrap: anywhere;
  }

  .paragraphContainer {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    font-weight: 400;
    background-color: #3f8cff;
    border-radius: 12px;
    border-top-left-radius: 0px;
    color: white;
    overflow-wrap: anywhere;
  }

  .attachment {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    padding: 0.5rem 1rem;
    background-color: #15c0e61a;
    border-radius: 12px;
  }

  .icon1Wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .attachment h2 {
    font-size: 1em;
    color: #2c8f73;
    font-weight: 400;
  }

  .icon1Wrapper {
    margin-right: 0.5rem;
  }

  .user-img {
    border-radius: 50%;
    display: flex;
    width: 2.5rem;
    height: 2.5rem;
    overflow: hidden;
  }
  .username {
    font-size: 0.85em;
    font-weight: 400;
    margin-right: 0.5rem;
  }
  .row {
    display: flex;
    flex-direction: row;
    margin-bottom: 0.2rem;
    align-items: center;
  }

  .attach {
    margin: 0.1rem;
    width: 6rem;
    height: 6rem;
  }

  .attach-img {
    border-radius: 12px;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }

  .attach-name {
    text-align: center;
    font-size: 0.7em;
    line-break: anywhere;
    max-width: 100%;
  }
</style>
